var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 56L7.95596 41.6208C5.51202 37.4026 4.22829 32.6176 4.2342 27.748C4.24064 12.4475 16.7478 0 32.1173 0C39.5756 0.00377267 46.5761 2.89326 51.841 8.1384C57.1059 13.3835 60.0026 20.3554 60 27.7702C59.9932 43.0696 47.4841 55.5194 32.1169 55.5194H32.1048C27.4386 55.5175 22.8536 54.3521 18.7809 52.1413L4 56Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0086 6.00006C19.8733 6.00006 10.0043 15.8649 10 27.9903C9.99405 32.1308 11.1601 36.1884 13.3633 39.6941L13.8867 40.5262L11.6639 48.6409L19.9905 46.4577L20.7946 46.934C24.1715 48.9381 28.0435 49.9978 31.992 50H32.0003C44.1263 50 53.9952 40.1341 53.9999 28.0079C54.009 25.1177 53.4448 22.2544 52.3397 19.5837C51.2347 16.9131 49.6109 14.4881 47.5622 12.4493C45.525 10.3993 43.1013 8.77374 40.4315 7.66672C37.7617 6.55971 34.8988 5.99322 32.0086 6.00006Z",
    fill: "url(#paint0_linear_76_793)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1192 16.2077C25.6028 15.0593 25.0594 15.036 24.5689 15.0161L23.2483 15C22.7889 15 22.0424 15.1726 21.4114 15.8629C20.7804 16.5533 19 18.2217 19 21.6152C19 25.0088 21.4687 28.2879 21.8127 28.7486C22.1567 29.2093 26.5786 36.3953 33.5812 39.16C39.4004 41.4576 40.5846 41.0006 41.8482 40.8858C43.1118 40.771 45.9241 39.2174 46.4978 37.6067C47.0716 35.9961 47.0719 34.6161 46.8999 34.3276C46.7279 34.0391 46.2685 33.8676 45.579 33.5225C44.8895 33.1773 41.503 31.5089 40.8716 31.2785C40.2402 31.0481 39.7811 30.9337 39.3213 31.624C38.8615 32.3144 37.5429 33.8673 37.1408 34.3276C36.7387 34.788 36.3374 34.8457 35.6478 34.5009C34.9583 34.1562 32.7399 33.4275 30.1078 31.0778C28.0599 29.2495 26.6775 26.9916 26.2751 26.3017C25.8726 25.6117 26.2323 25.238 26.5778 24.8944C26.887 24.5852 27.2666 24.0888 27.6117 23.6863C27.9568 23.2837 28.0704 22.9959 28.2997 22.5363C28.5291 22.0767 28.4148 21.673 28.2424 21.3282C28.07 20.9834 26.7315 17.5719 26.1192 16.2077Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_793",
    x1: 31.5521,
    y1: 8.64047,
    x2: 31.7751,
    y2: 46.2412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogo);
export default __webpack_public_path__ + "static/media/whatsapp-logo.e93a265b5a65ec1edb16a95955318f28.svg";
export { ForwardRef as ReactComponent };